import React from "react";
import { Form, Button } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import i18next from "i18next"
import { camelCaseToTitle } from '../../helpers/StringHelper';
import { getFormTitles, getInputHeadLines, getInputLabel, getSectionLabel, getSubtitles, inputTypeComponent, showHideInput } from "./helper";
import dayjs from "dayjs";


export function renderNestedInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress) {
  if (options[k].repeatable) {
    return renderRepeatable(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
  } else {
    return renderGroupOfInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
  }
}

export function renderRepeatable(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress) {
  const form = options[k];
  const formId = form.dataId || k;
  const allInputs = Object.keys(form.inputs).filter(i => {
    const input = form.inputs[i];
    return !excludedKeys.includes(i) && !input.excludeFromEdit &&
      showHideInput(input, values, undefined, undefined, setValues, `${formId}.${i}`)
  });
  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.type) ?
      getInputHeadLines(form.type, i, form, values)
      :
      <>
        {!form.repeatable ? <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} mb0 ${i ? 'mt-3' : ''}`}>
          {getInputLabel(form, values)}
        </h3> : (!form.hideSectionLabel ? <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} mb0 ${i ? 'mt-3' : ''}`}>
          {form.sectionLabel ? getSectionLabel(form.sectionLabel, values) : (form.label
            ? getInputLabel(form, values)
            : camelCaseToTitle(k))}
        </h3> : null)}
        <Form.List key={formId} name={formId}>
          {(fields, { add, remove }) => {
            const formData = form.repeatable
              ? (values[formId] || [])
              : (values[formId]
                ? [values[formId]] : []);
            if (fields.length === 0) {
              const formInputs = form.inputs
              if (formData.length) {
                formData.forEach(f => {
                  Object.keys(f).forEach(fkey => {
                    if (formInputs[fkey] && formInputs[fkey].type === 'total100' && !f[fkey]) {
                      f[fkey] = [{
                        type: null,
                        value: null
                      }];
                    } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].type)) {
                      f[fkey] = f[fkey] ? dayjs(f[fkey]) : undefined;
                    } else if (formInputs[fkey] && 'switch' === formInputs[fkey].type) {
                      f[fkey] = f[fkey] || false;
                    }
                  })
                  add(f);
                })
              } else {
                const fData = {};
                Object.keys(formInputs).forEach(fkey => {
                  if (formInputs[fkey] && formInputs[fkey].type === 'total100') {
                    fData[fkey] = [{
                      type: null,
                      value: null
                    }];
                  } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].type)) {
                    fData[fkey] = fData[fkey] ? dayjs() : undefined;
                  } else if (formInputs[fkey] && 'switch' === formInputs[fkey].type) {
                    fData[fkey] = fData[fkey] || false;
                  }
                })
                add(fData);
              }
            }
            return <React.Fragment>
              {fields.map(field => <React.Fragment key={`${formId}-${field.name}`}>
                {form.repeatable ?
                  <div className="d-flex">
                    <h4 className="title-semibold-4" style={{
                      marginBottom: '-13px',
                      marginTop: '0.5em',
                      background: 'white',
                      marginLeft: '15px',
                      padding: '0px 5px',
                      color: '#2E90FA',
                    }}>
                      {/* {form.label ? getInputLabel(form, values) : ''}&nbsp; */}
                      {`#${field.name + 1}`}
                    </h4>
                    <div className="remove-button-for-repeatable">
                      {(formData.filter(k => Object.keys(k).length > 0).length >= 1 || fields.length > 1) && (typeof form.canDelete !== 'function' || form.canDelete(
                        Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {})
                      ))
                        ? <Button type="link" danger onClick={() => {
                          remove(field.name);
                          if (fields.length === 1) {
                            add({});
                          }
                        }}><DeleteOutlined />
                          {/* {i18next.t('Remove')} */}
                        </Button> : null}
                    </div>
                  </div>
                  : null}
                <div className={form.repeatable ? "repeatable" : ''}>
                  {Object.keys(form.inputs)
                    .filter(i => !excludedKeys.includes(i) && !form.inputs[i].excludeFromEdit)
                    .map((inp, ii) => {
                      const input = form.inputs[inp];
                      const inputId = input.dataId || inp;
                      const inputValues = Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {});
                      const value = inputValues[inputId];
                      const commentValue = inputValues[`${inputId}Comment`];
                      const inputData = getData(formId, input, value, commentValue, `${formId}[${field.name}].${inputId}`, `${formId}.${inputId}`);
                      const subtitles = form.subtitles || null;
                      inputData.repeatIndex = field.name;
                      inputData.inputName = inputId;
                      inputData.repeatValues = inputValues;
                      if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
                        inputData.groupInputs = inputData.groupInputs.map(gpI => {
                          gpI.data.inputName = gpI.data.name;
                          gpI.data.repeatIndex = field.name;
                          gpI.data.name = formId;
                          return gpI;
                        });
                      }

                      const rules = inputData.rules
                        ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
                        : [];

                      const requiredRule = rules.find((r) => r.required);

                      if (requiredRule && input.type === 'text') {
                        rules.push({ whitespace: true, message: requiredRule.message || '' });
                      }

                      return showHideInput(input, values, field.name, inputValues, setValues, `${formId}[${field.name}].${inputId}`) ?
                        <React.Fragment key={`${i}${ii}`}>
                          <div key={ii} className={form.repeatable
                            ? `inputs` : ""}>
                            {getSubtitles(subtitles, input.position, values, field.name, inputValues)}
                            {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.type) ?
                              getInputHeadLines(input.type, i, input, values)
                              :
                              <>
                                <Form.Item
                                  {...field}
                                  required={
                                    inputData.rules && inputData.rules instanceof Array &&
                                      inputData.rules.filter(r => r.required).length > 0 ? true : false
                                  }
                                  {...(['total100', 'group'].includes(input.type) ? {} : {
                                    name: [field.name, inputId],
                                    fieldKey: [field.fieldKey, inputId],
                                    initialValue: inputData.value,
                                  })}
                                  {...(['upload'].includes(input.type) ? {
                                    valuePropName: "fileList",
                                    getValueFromEvent: (e) => {
                                      if (Array.isArray(e)) {
                                        return e;
                                      }
                                      return e && e.fileList && e.fileList.map(f => {
                                        if (f.response) {
                                          return f.response;
                                        }
                                        return f;
                                      })
                                    }
                                  } : {})}
                                  style={input.showOnView === false ? { display: 'none' } : {}}
                                  {...(['switch'].includes(input.type) ? {
                                    labelCol: { span: 20 },
                                    style: {
                                      ...(input.showOnView === false ? { display: 'none' } : {}),
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                    }
                                  } : {})}
                                  label={getInputLabel(input, values)}
                                  rules={rules}
                                  className={input.comment ? `with-comment i-${input.type}` : `i-${input.type}`}
                                  extra={input.comment ?
                                    (<Button
                                      disabled={inputData.props.disabled}
                                      type="link"
                                      onClick={() => {
                                        const inputValues = Array.isArray(values[formId])
                                          ? (values[formId][field.name] || {})
                                          : (values[formId] || {});
                                        inputValues[`${inputData.inputName}Comment`] =
                                          !inputData.commentValue ? '' : undefined;
                                        if (Array.isArray(values[formId])) {
                                          values[formId][field.name] = inputValues;
                                        } else {
                                          values[formId] = inputValues;
                                        }
                                        setValues({ ...values });
                                      }}>
                                      {i18next.t(!inputData.commentValue ? 'Add Comment' : 'Remove Comment')}
                                    </Button>) : null}
                                  data-id={inputData.inputName}>
                                  {inputTypeComponent[input.type]
                                    ? inputTypeComponent[input.type](inputData, {
                                      form: MainForm,
                                      forms: options,
                                      allForms: plainForms,
                                      setFormValues: setValues,
                                      remove,
                                      add,
                                      setAddress
                                    }) : console.log(input)}
                                </Form.Item>
                                {input.comment ?
                                  <Form.Item
                                    name={[field.name, `${inputData.inputName}Comment`]}
                                    fieldKey={[field.fieldKey, `${inputData.inputName}Comment`]}
                                    initialValue={inputData.commentValue}
                                    hidden={!inputData.commentValue}>
                                    {inputTypeComponent.comment(inputData, {
                                      form: MainForm,
                                      forms: options,
                                      setFormValues: setValues
                                    })}
                                  </Form.Item> : null}
                              </>
                            }
                          </div>
                        </React.Fragment> : null
                    })}
                </div>
              </React.Fragment>
              )}
              {form.repeatable
                ? <Button type="dashed" style={{ margin: '10px 0px 30px', borderRadius: '2px' }} block onClick={() => add({})}><PlusCircleOutlined /> {form.repeatLabel || i18next.t('Add New')}</Button>
                : null}
            </React.Fragment>
          }}
        </Form.List>
      </>
    }
  </React.Fragment> : null

}
export function renderGroupOfInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress) {
  const form = options[k];
  const formId = form.dataId || k;
  const allInputs = Object.keys(form.inputs).filter(i => !excludedKeys.includes(i) && !form.inputs[i].excludeFromEdit);
  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.type) ?
      getInputHeadLines(form.type, i, form, values)
      :
      getGrouContent(form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress)
    }
  </React.Fragment> : null

}
const getGrouContent = (form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress) => {
  const label = getInputLabel(form, values);
  const hasLabel = label && ((typeof label === 'string' && (label || '').trim() !== '') || typeof label === 'object') ? true : false;
  return <>
    {hasLabel ? <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} ${i ? 'mt-3 mb-1' : ''}`}>
      {label}
    </h3> : null}
    <div className={hasLabel ? "mb-4" : ""}>
      {Object.keys(form.inputs)
        .filter(i => !excludedKeys.includes(i) && !form.inputs[i].excludeFromEdit)
        .map((inp, ii) => {
          const input = form.inputs[inp];
          const inputId = input.dataId || inp;
          const inputValues = Array.isArray(values[formId]) ? (values[formId] || {}) : (values[formId] || {});
          const value = inputValues[inputId];
          const commentValue = inputValues[`${inputId}Comment`];
          const inputData = getData(formId, input, value, commentValue, `${formId}.${inputId}`, `${formId}.${inputId}`);
          const subtitles = form.subtitles || null;
          inputData.repeatIndex = undefined;
          inputData.inputName = inputId;
          inputData.repeatValues = inputValues;
          if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
            inputData.groupInputs = inputData.groupInputs.map(gpI => {
              gpI.data.inputName = gpI.data.name;
              gpI.data.repeatIndex = undefined;
              gpI.data.name = formId;
              return gpI;
            });
          }

          const rules = inputData.rules
            ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
            : [];

          const requiredRule = rules.find((r) => r.required);

          if (requiredRule && input.type === 'text') {
            rules.push({ whitespace: true, message: requiredRule.message || '' });
          }

          return showHideInput(input, values, undefined, inputValues, setValues, `${formId}.${inputId}`) ?
            <React.Fragment key={`${i}${ii}`}>
              <div key={ii}>
                {getSubtitles(subtitles, input.position, values, undefined, inputValues)}
                {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.type) ?
                  getInputHeadLines(input.type, i, input, values)
                  :
                  <>
                    <Form.Item
                      required={
                        inputData.rules && inputData.rules instanceof Array &&
                          inputData.rules.filter(r => r.required).length > 0 ? true : false
                      }
                      {...(['total100', 'group'].includes(input.type) ? {} : {
                        name: [formId, inputId],
                        fieldKey: [formId, inputId],
                        initialValue: inputData.value,
                      })}
                      {...(['upload'].includes(input.type) ? {
                        valuePropName: "fileList",
                        getValueFromEvent: (e) => {
                          if (Array.isArray(e)) {
                            return e;
                          }
                          return e && e.fileList && e.fileList.map(f => {
                            if (f.response) {
                              return f.response;
                            }
                            return f;
                          })
                        }
                      } : {})}
                      style={input.showOnView === false ? { display: 'none' } : {}}
                      {...(['switch'].includes(input.type) ? {
                        labelCol: { span: 20 },
                        style: {
                          ...(input.showOnView === false ? { display: 'none' } : {}),
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }
                      } : {})}
                      label={getInputLabel(input, values)}
                      rules={rules}
                      className={input.comment ? `with-comment i-${input.type}` : `i-${input.type}`}
                      extra={input.comment ?
                        (<Button
                          disabled={inputData.props.disabled}
                          type="link"
                          onClick={() => {
                            const inputValues = Array.isArray(values[formId])
                              ? (values[formId] || {})
                              : (values[formId] || {});
                            inputValues[`${inputData.inputName}Comment`] =
                              !inputData.commentValue ? '' : undefined;
                            if (Array.isArray(values[formId])) {
                              values[formId] = inputValues;
                            } else {
                              values[formId] = inputValues;
                            }
                            setValues({ ...values });
                          }}>
                          {i18next.t(!inputData.commentValue ? 'Add Comment' : 'Remove Comment')}
                        </Button>) : null}
                      data-id={inputData.inputName}>

                      {inputTypeComponent[input.type]
                        ? inputTypeComponent[input.type](inputData, {
                          form: MainForm,
                          forms: options,
                          allForms: plainForms,
                          setFormValues: setValues,
                          setAddress
                        }) : console.log(input)}
                    </Form.Item>
                    {input.comment ?
                      <Form.Item
                        name={[formId, `${inputData.inputName}Comment`]}
                        fieldKey={[formId, `${inputData.inputName}Comment`]}
                        initialValue={inputData.commentValue}
                        hidden={!inputData.commentValue}>
                        {inputTypeComponent.comment(inputData, {
                          form: MainForm,
                          forms: options,
                          setFormValues: setValues
                        })}
                      </Form.Item> : null}
                  </>
                }
              </div>
            </React.Fragment> : null
        })}


    </div>
  </>
}
